module.exports = __webpack_public_path__ + "static/media/service.2b3a0135.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/service.jpg
// module id = 488
// module chunks = 0